module.exports = __webpack_public_path__ + "static/media/flag-vi.51c1f46a.webp";